import {
    useCreateConversationQuickReply,
    useUpdateConversationQuickReply
} from '../../../hooks/useConversationQuickReplies';
import { useToast } from '../../../providers/ToastProvider';
import type {
    ConversationQuickReply,
    CreateQuickReplyBody
} from '../../../services/conversationQuickReplies';
import { apiErrorMessage } from '../../../utils/apiError';

export function useQuickReplyActions() {
    const { showToast } = useToast();
    const create = useCreateConversationQuickReply();
    const update = useUpdateConversationQuickReply();

    // Rethrows so the form shows the API's 400/409 message inline.
    const save = async (reply: ConversationQuickReply | null, body: CreateQuickReplyBody) => {
        if (reply) await update.mutateAsync({ id: reply.id, body });
        else await create.mutateAsync(body);
        showToast(reply ? 'Quick reply saved' : 'Quick reply created', 'success');
    };

    // Soft delete: the list endpoint only returns active replies.
    const remove = async (reply: ConversationQuickReply) => {
        try {
            await update.mutateAsync({ id: reply.id, body: { isActive: false } });
            showToast('Quick reply deleted', 'success');
        } catch (error) {
            showToast(apiErrorMessage(error, 'Could not delete the quick reply.'), 'error');
        }
    };

    return { save, remove, isPending: create.isPending || update.isPending };
}
